import React from 'react';
import { motion } from 'framer-motion';
export function DevicePreview() {
  return <section className="py-24 bg-warm-white overflow-hidden" data-id="element-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-29">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-30">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-31">
            <h2 className="text-4xl md:text-5xl font-bold text-espresso mb-6 leading-tight" data-id="element-32">
              Tu panadería digital, <br data-id="element-33" />
              <span className="text-terracotta italic font-normal" data-id="element-34">
                siempre contigo
              </span>
            </h2>
            <p className="text-lg text-espresso/80 mb-8 leading-relaxed" data-id="element-35">
              Diseñado con una estética editorial premium, este ebook está
              optimizado para que lo leas cómodamente en tu teléfono mientras
              amasas, en tu tablet en la cocina, o en tu computadora para
              estudiar la teoría.
            </p>
            <ul className="space-y-4 text-espresso/90 mb-10" data-id="element-36">
              <li className="flex items-center gap-3" data-id="element-37">
                <span className="w-1.5 h-1.5 bg-bakery-brown rounded-full" data-id="element-38"></span>
                Formato PDF de alta resolución
              </li>
              <li className="flex items-center gap-3" data-id="element-39">
                <span className="w-1.5 h-1.5 bg-bakery-brown rounded-full" data-id="element-40"></span>
                Descarga inmediata tras la compra
              </li>
              <li className="flex items-center gap-3" data-id="element-41">
                <span className="w-1.5 h-1.5 bg-bakery-brown rounded-full" data-id="element-42"></span>
                Acceso de por vida a las actualizaciones
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="relative" data-id="element-43">
            <img src="https://cdn.magicpatterns.com/uploads/v8yeXFNu6biYb46SsG3RZD/Logo_.png" alt="Ebook en múltiples dispositivos" className="w-full h-auto drop-shadow-2xl" data-id="element-44" />
            {/* Decorative elements */}
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-beige rounded-full -z-10 blur-3xl opacity-50" data-id="element-45"></div>
            <div className="absolute -bottom-10 -left-10 w-60 h-60 bg-terracotta rounded-full -z-10 blur-3xl opacity-20" data-id="element-46"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}